import { MicrositeContext } from 'context';
import { useQual } from 'hooks';
import { useCallback, useContext } from 'react';

export type ExtraTrackingDetails = {
  promo_id?: string;
  micrositeCode?: string;
};

export const useCreateBaseTrackingEvent = () => {
  const { promoId } = useQual();
  const micrositeConfig = useContext(MicrositeContext);

  const addExtraEventDetails = useCallback(
    (event) => {
      const trackingDetails: ExtraTrackingDetails = {};

      if (promoId) {
        trackingDetails.promo_id = promoId;
      }
      if (micrositeConfig?.micrositeCode) {
        trackingDetails.micrositeCode = micrositeConfig.micrositeCode;
      }

      const eventWithTrackingDetails = {
        ...event,
        details: {
          ...event.details,
          ...trackingDetails,
        },
      };

      return eventWithTrackingDetails;
    },
    [micrositeConfig?.micrositeCode, promoId]
  );

  return { addExtraEventDetails };
};
